import { ServicesService } from './../../../services/services/servicesService';
import { AddVersionComponent } from './../add-version/add-version.component';
import { Component, OnInit, Input } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ngx-versions',
  templateUrl: './versions.component.html',
  styleUrls: ['./versions.component.scss'],
})
export class VersionsComponent implements OnInit {
  @Input() servicesHistories: any[];
  @Input() servicesId;

  constructor(private diag: NbDialogService, private sanitizer: DomSanitizer, private service: ServicesService) {}

  ngOnInit() {
    this.servicesHistories.forEach((element) => {
      element.updates = this.sanitizer.bypassSecurityTrustHtml(element.updates);
    });
  }

  refreshVersions() {}
  addversion() {
    this.diag.open(AddVersionComponent, { context: { serviceId: this.servicesId } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.service.getById(this.servicesId).subscribe((resp) => {
          this.servicesHistories = resp.servicesHistories;
        });
      }
    });
  }
}
